import { render, staticRenderFns } from "./BpCollapse.vue?vue&type=template&id=42ce8909&scoped=true&"
import script from "./BpCollapse.vue?vue&type=script&lang=js&"
export * from "./BpCollapse.vue?vue&type=script&lang=js&"
import style0 from "./BpCollapse.vue?vue&type=style&index=0&id=42ce8909&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42ce8909",
  null
  
)

export default component.exports